import { localize } from '@/utils/i18n.js'

export const text = {
    linkText: localize({
        ru: 'Вернуться к списку',
        en: 'Back to list'
    }),
    aboutCompany: localize({
        ru:
            'ПАО «Распадская» представляет собой группу интегрированных предприятий, специализирующуюся на производстве и реализации коксующегося угля и занимающую лидирующие позиции на российском рынке в своей отрасли. Группа расположена в городе Междуреченск, а также в Новокузнецком районе Кемеровской области и Республике Тыва.',
        en:
            'Raspadskaya is a group of integrated companies that specialises in the production and sale of coking coal and has leading positions in the Russian coal market. It is located in the town of Mezhdurechensk and also in the Novokuznetsky district of the Kemerovo region and the Tyva Republic.'
    }),
    aboutCompanyTitle: localize({
        ru: 'О компании',
        en: 'About company'
    }),
    contactsTitle: localize({
        ru: 'Контакты',
        en: 'Contacts'
    }),
    contacts: {
        typeName: localize({
            ru: 'Телефон:',
            en: 'Phone:'
        }),
        title: localize({
            ru: 'Ольга Щербакова',
            en: 'Olga Sherbakova'
        }),
        desc: localize({
            ru: 'Управление по связям с общественностью Распадской угольной компании',
            en: 'PR Department of Raspadskaya Coal Company'
        })
    }
}
